import { FiltersSelectionState } from '../../../../catalog/CatalogFiltersState';
import { type PropertyData } from '../../../../data/model';
import { ModalState } from '../../../../shared/ModalState';
import FacetFilterState from '../FacetFilterState';

export default class FabricFacetFiltersModalState extends ModalState {
  public constructor(
    public readonly filters: FacetFilterState[],
    public readonly selection: FiltersSelectionState,
    private readonly onApply: (properties: PropertyData[]) => void,
  ) {
    super();
  }

  public apply() {
    this.onApply(this.selection.properties);
    this.close();
  }

  public clearAll() {
    this.selection.clear();
  }
}
